import { useState, useEffect, useCallback } from 'react';
import api from 'services/api';
import useEscapeClose from 'hooks/useEscapeClose';

export default function FournisseursPage() {
  const [fournisseurs, setFournisseurs] = useState([]);
  const [factures, setFactures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('fournisseurs');
  const [showForm, setShowForm] = useState(false);
  const [showFactForm, setShowFactForm] = useState(false);
  const [form, setForm] = useState({ nom: '', contact: '', telephone: '', email: '', adresse: '', categorie: 'materiel' });
  const [factForm, setFactForm] = useState({ fournisseur_id: '', numero_facture: '', montant: '', date_facture: '', date_echeance: '', notes: '' });

  useEscapeClose(showForm || showFactForm, () => { setShowForm(false); setShowFactForm(false); });

  const load = useCallback(async () => {
    try {
      const [f, ff] = await Promise.all([api.get('/comptabilite/fournisseurs'), api.get('/comptabilite/fournisseurs/factures')]);
      setFournisseurs(f.data);
      setFactures(ff.data);
    } catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSubmit = async (e) => { e.preventDefault(); try { await api.post('/comptabilite/fournisseurs', form); setShowForm(false); load(); } catch {} };
  const handleFactSubmit = async (e) => { e.preventDefault(); try { await api.post('/comptabilite/fournisseurs/factures', factForm); setShowFactForm(false); load(); } catch {} };
  const marquerPayee = async (id) => { try { await api.put(`/comptabilite/fournisseurs/factures/${id}/payer`); load(); } catch {} };

  return (
    <div>
      <div className="stats-grid stats-grid--3">
        <div className="stat-card"><div className="stat-card-header"><span className="stat-card-label">Fournisseurs</span></div><div className="stat-card-value">{fournisseurs.length}</div></div>
        <div className="stat-card"><div className="stat-card-header"><span className="stat-card-label">Factures en attente</span></div><div className="stat-card-value" style={{ color: '#f57c00' }}>{factures.filter(f => f.statut === 'en_attente').length}</div></div>
        <div className="stat-card"><div className="stat-card-header"><span className="stat-card-label">Montant du</span></div><div className="stat-card-value" style={{ color: '#DC2626' }}>{factures.filter(f => f.statut === 'en_attente').reduce((s, f) => s + Number(f.montant), 0).toLocaleString()}</div><div className="stat-card-sub">FCFA</div></div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button className={`gss-btn ${tab === 'fournisseurs' ? 'gss-btn-primary' : ''}`} onClick={() => setTab('fournisseurs')}>Fournisseurs ({fournisseurs.length})</button>
        <button className={`gss-btn ${tab === 'factures' ? 'gss-btn-primary' : ''}`} onClick={() => setTab('factures')}>Factures fournisseurs ({factures.length})</button>
      </div>

      {tab === 'fournisseurs' && (
        <div className="content-card">
          <div className="gss-toolbar">
            <div className="content-card-title">Liste fournisseurs</div>
            <button className="gss-btn gss-btn-primary" onClick={() => setShowForm(true)}>+ Nouveau fournisseur</button>
          </div>
          {loading ? <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--gss-text-light)' }}>Chargement...</p> : (
            <div className="gss-table-wrap">
              <table className="gss-table">
                <thead><tr><th>Nom</th><th>Contact</th><th>Telephone</th><th>Email</th><th>Categorie</th></tr></thead>
                <tbody>
                  {fournisseurs.map(f => (
                    <tr key={f.id}>
                      <td style={{ fontWeight: 600 }}>{f.nom}</td>
                      <td>{f.contact || '-'}</td>
                      <td>{f.telephone || '-'}</td>
                      <td>{f.email || '-'}</td>
                      <td><span className="gss-badge">{f.categorie || '-'}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {tab === 'factures' && (
        <div className="content-card">
          <div className="gss-toolbar">
            <div className="content-card-title">Factures fournisseurs</div>
            <button className="gss-btn gss-btn-primary" onClick={() => setShowFactForm(true)}>+ Enregistrer facture</button>
          </div>
          <div className="gss-table-wrap">
            <table className="gss-table">
              <thead><tr><th>Fournisseur</th><th>N° Facture</th><th>Montant</th><th>Date</th><th>Echeance</th><th>Statut</th><th>Actions</th></tr></thead>
              <tbody>
                {factures.map(f => (
                  <tr key={f.id}>
                    <td style={{ fontWeight: 600 }}>{f.fournisseur_nom}</td>
                    <td>{f.numero_facture}</td>
                    <td style={{ textAlign: 'right', fontWeight: 600 }}>{Number(f.montant).toLocaleString()} F</td>
                    <td>{f.date_facture?.split('T')[0]}</td>
                    <td>{f.date_echeance?.split('T')[0] || '-'}</td>
                    <td><span className="gss-badge" style={{ background: f.statut === 'payee' ? '#2e7d3220' : '#f57c0020', color: f.statut === 'payee' ? '#2e7d32' : '#f57c00' }}>{f.statut === 'payee' ? 'Payee' : 'En attente'}</span></td>
                    <td>{f.statut !== 'payee' && <button className="gss-btn-sm" style={{ color: '#2e7d32' }} onClick={() => marquerPayee(f.id)}>Marquer payee</button>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showForm && (
        <div className="gss-modal-overlay" onClick={() => setShowForm(false)}>
          <div className="gss-modal" onClick={e => e.stopPropagation()}>
            <div className="gss-modal-header"><h2>Nouveau fournisseur</h2><button className="gss-modal-close" onClick={() => setShowForm(false)}>&times;</button></div>
            <form onSubmit={handleSubmit}>
              <div style={{ padding: '1.5rem' }}>
                <div className="gss-form-grid">
                  <div className="gss-field"><label>Nom *</label><input className="gss-input" required value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} /></div>
                  <div className="gss-field"><label>Contact</label><input className="gss-input" value={form.contact} onChange={e => setForm({ ...form, contact: e.target.value })} /></div>
                  <div className="gss-field"><label>Telephone</label><input className="gss-input" value={form.telephone} onChange={e => setForm({ ...form, telephone: e.target.value })} /></div>
                  <div className="gss-field"><label>Email</label><input className="gss-input" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></div>
                  <div className="gss-field"><label>Categorie</label>
                    <select className="gss-input" value={form.categorie} onChange={e => setForm({ ...form, categorie: e.target.value })}>
                      <option value="materiel">Materiel</option><option value="service">Service</option><option value="autre">Autre</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="gss-modal-actions"><button type="button" className="gss-btn-cancel" onClick={() => setShowForm(false)}>Annuler</button><button type="submit" className="gss-btn-deploy">Creer</button></div>
            </form>
          </div>
        </div>
      )}

      {showFactForm && (
        <div className="gss-modal-overlay" onClick={() => setShowFactForm(false)}>
          <div className="gss-modal" onClick={e => e.stopPropagation()}>
            <div className="gss-modal-header"><h2>Enregistrer facture fournisseur</h2><button className="gss-modal-close" onClick={() => setShowFactForm(false)}>&times;</button></div>
            <form onSubmit={handleFactSubmit}>
              <div style={{ padding: '1.5rem' }}>
                <div className="gss-form-grid">
                  <div className="gss-field"><label>Fournisseur *</label>
                    <select className="gss-input" required value={factForm.fournisseur_id} onChange={e => setFactForm({ ...factForm, fournisseur_id: e.target.value })}>
                      <option value="">-- Choisir --</option>
                      {fournisseurs.map(f => <option key={f.id} value={f.id}>{f.nom}</option>)}
                    </select>
                  </div>
                  <div className="gss-field"><label>N° Facture</label><input className="gss-input" value={factForm.numero_facture} onChange={e => setFactForm({ ...factForm, numero_facture: e.target.value })} /></div>
                  <div className="gss-field"><label>Montant *</label><input className="gss-input" type="number" required min="0" value={factForm.montant} onChange={e => setFactForm({ ...factForm, montant: e.target.value })} /></div>
                  <div className="gss-field"><label>Date facture</label><input className="gss-input" type="date" value={factForm.date_facture} onChange={e => setFactForm({ ...factForm, date_facture: e.target.value })} /></div>
                  <div className="gss-field"><label>Date echeance</label><input className="gss-input" type="date" value={factForm.date_echeance} onChange={e => setFactForm({ ...factForm, date_echeance: e.target.value })} /></div>
                </div>
              </div>
              <div className="gss-modal-actions"><button type="button" className="gss-btn-cancel" onClick={() => setShowFactForm(false)}>Annuler</button><button type="submit" className="gss-btn-deploy">Enregistrer</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
